module.exports = __webpack_public_path__ + "static/img/organilog-03.2611d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-03.png
// module id = 120
// module chunks = 0